module.exports = __webpack_public_path__ + "598bed55f1790aae482bcce81de59010.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/barn_owl_hoot.png
// module id = 2886
// module chunks = 0